import * as storage from '../localStorage'
import { browserHistory } from 'react-router'

export const loginSuccess = (data) => {
  return (dispatch, getState) => {
    storage.setToken(data.auth_token)
    storage.setCurrentUser(data.user)
    dispatch(setCurrentUser(data.user))
    browserHistory.push('/')
  }
}

export const logout = () => {
  return (dispatch, getState) => {
    storage.removeToken()
    storage.removeCurrentUser()
    dispatch(logoutAction())
    browserHistory.push('/login')
  }
}

export const newSession = () => {
  return (dispatch, getState) => {
    dispatch({type: 'NEW_SESSION'})
    browserHistory.push('/welcome')
  }
}

const logoutAction = () => {
  return {
    type: 'USER_LOGOUT'
  }
}

const setCurrentUser = (user) => {
  return {
    type: 'SET_CURRENT_USER',
    value: user
  }
}



// WEBPACK FOOTER //
// ./src/actions/current-user.js